import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useAuthStore } from '../store/authStore';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { refreshUser } = useAuthStore();

  useEffect(() => {
    const success = searchParams.get('success');
    if (success === 'true') {
      setTimeout(async () => {
        try {
          await refreshUser?.();
        } catch {}
        setLoading(false);
      }, 2000);
    } else {
      navigate('/pricing');
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Activating your subscription...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-xl p-12 max-w-md w-full text-center"
      >
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.2, type: 'spring' }}>
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
        </motion.div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Successful! 🎉</h1>
        <p className="text-gray-600 mb-8">
          Your subscription has been activated. You now have access to all features in your new plan.
        </p>
        <div className="space-y-3">
          <button onClick={() => navigate('/dashboard')} className="block w-full py-3 px-6 bg-gradient-to-r from-primary-600 to-secondary-600 text-white rounded-lg font-semibold hover:shadow-lg transition">
            Go to Dashboard
          </button>
          <button onClick={() => navigate('/staking')} className="block w-full py-3 px-6 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition">
            Explore Staking Options
          </button>
        </div>
      </motion.div>
    </div>
  );
}
